import { GET_LOAN_REPAYMENT_REPORT } from "../../../Types";

const LoanRepaymentReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_LOAN_REPAYMENT_REPORT:
      return action.payload;

    default:
      return state;
  }
};
export default LoanRepaymentReportReducer;
